import { type TabsProps } from "antd";
import i18n from "../../../i18n";
import { formatTranslation } from "../../../shared/utils/translationUtils";
import SeedsComponent from "./seeds";
import CropProtectionComponent from "./cropProtection";
import FertiliserComponent from "./fertiliser";
import "../style.less";
import { type ProtocolResponse } from "../types";

export const getRatesAndDosageTabs = (
  protocolData: ProtocolResponse | null
): TabsProps["items"] =>
  [
    {
      key: "seed",
      label: (
        <div className="label-style">
          {formatTranslation(i18n.t("ratesDosage.tabs.seeds"))}
        </div>
      ),
      children: <SeedsComponent />,
    },
    {
      key: "biological",
      label: formatTranslation(i18n.t("ratesDosage.tabs.cpAndBiologicals")),
      children: <CropProtectionComponent />,
    },
    {
      key: "nutrient",
      label: formatTranslation(i18n.t("ratesDosage.tabs.fertiliser")),
      children: <FertiliserComponent />,
    },
  ].filter((val) => protocolData?.protocol_type?.includes(val?.key));
